// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__G2DPq","inputWrap":"Table_inputWrap__1ZIP-","col":"Table_col__syE-p","bmiTooltip":"Table_bmiTooltip__1RX4A"};